import React, { useRef } from 'react';
import { FormInstance } from 'antd';
import { ActionType, ProColumns, RequestData } from '@ant-design/pro-table';
import { SortOrder } from 'antd/es/table/interface';
import { Dayjs } from 'dayjs';
import {
  addKeyToTableData, getSorterParams, queryFilterParams,
} from '../../../../utils';
import Table from '../../../Common/Table';
import { useLazyUsersActivitiesQuery } from '../../../../store/dashboard';

interface UsersActivities {
  id?: string,
  name?: string,
  views?: number,
  users?: number
  viewsPerUser?: number,
  avgTime?: string | number,
}
interface UsersActivitiesProps {
  range: [Dayjs, Dayjs]
}

export default function UsersActivitiesTable({ range }:UsersActivitiesProps): JSX.Element {
  const formRef = useRef<FormInstance>();
  const actionRef = useRef<ActionType>();

  const [fetchData] = useLazyUsersActivitiesQuery();

  const tableRequest = async (
    { current, pageSize, ...args }: Record<string, string>,
    sorter: Record<string, SortOrder>,
  ): Promise<RequestData<UsersActivities>> => {
    const params = queryFilterParams({
      page: current ? `${current}` : '1',
      pageSize: pageSize ? `${pageSize}` : '10',
      ...args,
      fromDate: range[0].toDate().toISOString() || '',
      tillDate: range[1].toDate().toISOString() || '',
      ...getSorterParams(sorter),
    });

    return fetchData(params).then((res) => ({
      data: res?.data?.data ? addKeyToTableData(res.data.data) : [],
      success: res.isSuccess,
      total: res?.data?.meta.totalItems || 0,
    }));
  };

  const columns: ProColumns<UsersActivities>[] = [
    {
      title: 'Page',
      dataIndex: 'name',
      sorter: false,
    },
    {
      title: 'Views',
      dataIndex: 'views',
      sorter: true,
    },
    {
      title: 'Users',
      dataIndex: 'users',
      sorter: true,
    },
    {
      title: 'Views per user',
      dataIndex: 'viewsPerUser',
      sorter: true,
    },
    {
      title: 'Avg. engagement time',
      dataIndex: 'avgTime',
      width: 220,
      sorter: true,
    },
  ];

  return (
    <Table
      search={false}
      formRef={formRef}
      actionRef={actionRef}
      style={{ marginTop: 24 }}
      toolbar={{
        title: 'User activities',
        settings: undefined,
      }}
      showSorterTooltip={false}
      columns={columns}
      request={tableRequest}
    />
  );
}
